import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["ruleElement", "calendarElement", "timeslotContainer", "starttimeContainer"];
  static values = {
    activeTab: { type: String, default: "rule" },
    timeIndex: { type: Number, default: 1 },
    locale: String,
    url: String,
    event: String,
    datesOrTimeNotSet: String,
    datesOrTimeNotChosen: String
  }

  showRuleTab(event) {
    event.preventDefault();
    this.activeTabValue = "rule";
  }

  showCalendarTab(event) {
    event.preventDefault();
    this.activeTabValue = "calendar";
  }

  activeTabValueChanged() {
    this.ruleElementTargets.forEach((element) => {
      element.hidden = this.activeTabValue == "calendar"
    });
    this.calendarElementTargets.forEach((element) => {
      element.hidden = this.activeTabValue == "rule"
    });
  }

  addTimeslot(event) {
    event.preventDefault();
    this.timeslotContainerTarget.insertAdjacentHTML("beforeend", this.timeslotMarkup());
    $(`#clockpicker${this.timeIndexValue}`).clockpicker({
      autoclose: true
    });
    this.timeIndexValue++;
  }

  deleteTimeslot(event) {
    event.target.parentNode.remove();
  }

  addStartTime(event) {
    event.preventDefault();
    this.starttimeContainerTarget.insertAdjacentHTML("beforeend", this.starttimeMarkup());
    $(`#clockpicker${this.timeIndexValue}`).clockpicker({
      autoclose: true
    });
    this.timeIndexValue++;
  }
  
  createEventsByRule(event) {
    const start_date = document.getElementById("start_date").value
    const end_date = document.getElementById("end_date").value
    var timeEmpty = false
    const timeslots = [...document.getElementsByClassName("time-item rule")].map((item) => {
      let inputs = item.getElementsByTagName("input")
      if ( !timeEmpty ) {
        timeEmpty = inputs[0].value.length == 0
      }
      return {
        "time": inputs[0].value,
        "monday": inputs[1].checked,
        "tuesday": inputs[2].checked,
        "wednesday": inputs[3].checked,
        "thursday": inputs[4].checked,
        "friday": inputs[5].checked,
        "saturday": inputs[6].checked,
        "sunday": inputs[7].checked
      }
    })
    if ( start_date.length == 0 || end_date.length == 0 || timeEmpty ){
      toastr && toastr.error(this.datesOrTimeNotSetValue);
    } else {
      fetch(this.urlValue,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          method: "POST",
          body: JSON.stringify({ timeslots: timeslots, start_date: start_date, end_date: end_date, creation_way: this.activeTabValue, event_id: this.eventValue })
        })
        .then(function (res) { console.log(res); res.json().then(data => window.location = data.path ) })
        .catch(function (res) { console.log(res) })
    }
  }

  createEventsByCalendar(event) {
    const dates = document.getElementById("dates").value
    var timeEmpty = false
    const startTimes = [...document.getElementsByClassName("time-item calendar")].map((item) => {
      let inputs = item.getElementsByTagName("input")
      if ( !timeEmpty ) {
        timeEmpty = inputs[0].value.length == 0
      }
      return {
        "time": inputs[0].value
      }
    })
    if ( dates.length == 0 || timeEmpty ){
      toastr && toastr.error(this.datesOrTimeNotChosenValue);
    } else {
      fetch(this.urlValue,
        {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          method: "POST",
          body: JSON.stringify({ start_times: startTimes, dates: dates, creation_way: this.activeTabValue, event_id: this.eventValue })
        })
        .then(function (res) { console.log(res); res.json().then(data => window.location = data.path ) })
        .catch(function (res) { console.log(res) })
    }
  }

  starttimeMarkup() {
    return `<div class="time-item calendar" id="starttime${this.timeIndexValue}"><div class="clock">`
           +`<div class="input-group clockpicker" id="clockpicker${this.timeIndexValue}">`
           +`<input type="text" class="form-control" name="time" placeholder="00:00">`
           +`<span class="input-group-addon"><span class="glyphicon glyphicon-time"></span></span>`
           +`</div></div><div class="delete-control" data-action="click->availability-interface#deleteTimeslot">❌</div></div>`;
  }

  timeslotMarkup() {
    const weekdays = this.getWeekDays();
    const weekdaysHtml = weekdays.map((item) =>`<div class="weekday"><div class="base-checkbox"><input type="checkbox" name="${item.dayId}" id="${item.dayId}" value="${item.dayId}"> <label for="${item.dayId}">${item.dayName}</label></div></div>`).join("")
    return `<div class="time-item rule" id="timeslot${this.timeIndexValue}"><div class="clock">`
           +`<div class="input-group clockpicker" id="clockpicker${this.timeIndexValue}">`
           +`<input type="text" class="form-control" name="time" placeholder="00:00">`
           +`<span class="input-group-addon"><span class="glyphicon glyphicon-time"></span></span>`
           +`</div></div>${weekdaysHtml}<div class="delete-control" data-action="click->availability-interface#deleteTimeslot">❌</div></div>`;
  }

  getWeekDays() {
    const baseDate = new Date(Date.UTC(2024, 1, 26)); // just a Monday
    const weekDays = [];
    for (let i = 0; i < 7; i++) {
      weekDays.push(
        {
          "dayName": baseDate.toLocaleDateString(this.localeValue, { weekday: 'short' }).toUpperCase(),
          "dayId": `${baseDate.toLocaleDateString("en", { weekday: 'long' })}${this.timeIndexValue}`
        }
      );
      baseDate.setDate(baseDate.getDate() + 1);
    }
    return weekDays;
  }
}